import { generatePath } from 'react-router-dom'
import {
  SALES_CHANNELS,
  SALES_CHANNELS_UPDATE,
  SALES_CHANNELS_CREATE,
} from 'constants/api-paths'
import request from './request'
import { formatError } from './error'

export const requestSalesChannelsList = async () => (
  request.get(SALES_CHANNELS)
    .then((resp) => resp.data)
    .catch((error) => formatError(error))
)

export const requestSalesChannelsUpdate = async (id, params) => {
  const path = generatePath(SALES_CHANNELS_UPDATE, { id })
  return request.patch(path, params)
    .then((resp) => resp.data)
    .catch((error) => formatError(error))
}

export const requestSalesChannelsCreate = async (params) => (
  request.post(SALES_CHANNELS_CREATE, params)
    .then((resp) => resp.data)
    .catch((error) => formatError(error))
)
